<template>
  <v-container>
    <v-row>
        <v-col cols="4">
            <v-card>
                <v-toolbar dark color="primary" dense>
                    Users
                </v-toolbar>
                <v-card-actions>
                    <v-btn :loading="loading" @click="doImportUsers">Import Users into fictional users</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
        <v-col cols="4">
            <v-card>
                <v-toolbar dark color="primary" dense>
                    Contact Groups
                </v-toolbar>
                <v-card-actions>
                    <v-btn :loading="loading" @click="doContactGroups">Create Contact Groups</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
        <v-col cols="4">
            <v-card>
                <v-toolbar dark color="primary" dense>
                    Clients
                </v-toolbar>
                <v-card-actions>
                    <v-btn :loading="loading" @click="doImportClients">Import Clients</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="4">
            <v-card>
                <v-toolbar dark color="primary" dense>
                    Countries
                </v-toolbar>
                <v-card-actions>
                    <BexioCountryCheck />
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BexioCountryCheck from "../../components/bexio/CountryCheck.vue"

export default {
    components: { BexioCountryCheck },
    computed: {
        ...mapGetters('bexio', ['loading'])
    },
    methods: {
        ...mapActions('bexio', {
            importUsers: 'importUsers',
            importClients: 'importClients',
            createContactGroups: 'createContactGroups'
        }),
        doImportUsers () {
            this.importUsers()
                .then(({fictionalUsers}) => {
                    console.log(fictionalUsers)
                })
        },
        doContactGroups () {
            this.createContactGroups()
                .then(() => {})
        },
        doImportClients () {
            this.importClients()
                .then(({clients}) => {
                    console.log(clients)
                })
        }
    }
}
</script>

<style>

</style>